"use strict";
/**
 ShapeDiver 3D Viewer Application

 MaterialParser.ts

 Content:
   Logic to parse the incoming JSONMaterials into desired format.

  Copyright (c) 2018 ShapeDiver GmbH

  @module MaterialParser
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MaterialParser = void 0;
/**
 Import THREE
 @ignore
*/
var THREE = __importStar(require("../../externals/three"));
var MaterialPresets_1 = require("./MaterialPresets");
/**
 * Utility function to convert from all kinds of string formats to a tinycolor
 * @function
 * @ignore
 */
var toTinyColor_1 = __importDefault(require("../util/toTinyColor"));
/**
 * Texture loader function with built in caching
 * @function
 * @ignore
 */
var TextureLoader_1 = __importDefault(require("../singletons/TextureLoader"));
var loadTexture = TextureLoader_1.default.loadTexture;
/**
 * Global utilities
 */
var GlobalUtils_1 = __importDefault(require("../util/GlobalUtils"));
var MaterialPropertiesStandard_1 = require("../materials/MaterialPropertiesStandard");
var MaterialPropertiesGem_1 = __importDefault(require("../materials/MaterialPropertiesGem"));
var LoadCubeTextureFromJSONError = /** @class */ (function (_super) {
    __extends(LoadCubeTextureFromJSONError, _super);
    function LoadCubeTextureFromJSONError(msg) {
        if (msg === void 0) { msg = 'Input object is not a valid JSON cube texture definition.'; }
        return _super.call(this, msg) || this;
    }
    return LoadCubeTextureFromJSONError;
}(Error));
var MaterialParser = /** @class */ (function () {
    function MaterialParser(requestHeaders) {
        this._materialPresets = MaterialPresets_1.MaterialPresetsInstance;
        this.requestHeaders = requestHeaders;
    }
    // #endregion Properties (4)
    // #region Public Methods (1)
    /**
      * Create a material definition object from a material object as formatted in the
      * ShapeDiver model view interface.
      *
      * Supported versions: 1.0 and 2.0
      *
      * All textures will be downloaded.
      *
      * @param  {module:JSONMaterial~JSONMaterial(1)|module:JSONMaterial~JSONMaterial(2)} JSONMaterialObject Material definition in model view interface definition
      * @return {Promise<module:MaterialAttributes~MaterialAttributes>}   Pointer to this object if successful, null otherwise
      */
    MaterialParser.prototype.fromJSONMaterialObject = function (JSONMaterialObject) {
        var _this = this;
        var materialType = 'standard';
        if (JSONMaterialObject.hasOwnProperty('materialType'))
            materialType = JSONMaterialObject.materialType;
        if (materialType === 'gem') {
            if (!JSONMaterialObject.hasOwnProperty('version'))
                JSONMaterialObject.version = '1.0';
            return this.processGemMaterial(JSONMaterialObject);
        }
        else {
            if (!JSONMaterialObject.hasOwnProperty('version')) {
                return Promise.reject(new Error('Material definition did not have version number defined'));
            }
            // if we find a preset, we get the definition
            if (JSONMaterialObject.hasOwnProperty('materialpreset')) {
                // wrap into a deffered promise
                return new Promise(function (resolve, reject) {
                    _this._materialPresets.fromId(JSONMaterialObject.materialpreset).then(function (mat) {
                        var presetMaterial = GlobalUtils_1.default.deepCopy(mat);
                        // if the color that was sent with the preset definition is white, we ignore that and keep the color
                        // that was set by the preset. if there is a different color, we have to use it.
                        if (JSONMaterialObject.hasOwnProperty('color') && (parseInt(JSONMaterialObject.color[0]) !== 255 || parseInt(JSONMaterialObject.color[1]) !== 255 || parseInt(JSONMaterialObject.color[2]) !== 255)) {
                            presetMaterial.color = JSONMaterialObject.color;
                        }
                        // if there were maps specified together with the presets, we have to respect that as well
                        if (JSONMaterialObject.hasOwnProperty('bitmaptexture')) {
                            presetMaterial.bitmaptexture = JSONMaterialObject.bitmaptexture;
                        }
                        if (JSONMaterialObject.hasOwnProperty('bumptexture')) {
                            presetMaterial.bumptexture = JSONMaterialObject.bumptexture;
                        }
                        // process the combined material definition
                        // #SS-871 process preset material according to its version
                        resolve(_this.processStandardMaterial(presetMaterial, '2.0'));
                    }, function (reason) { return reject(reason); });
                });
            }
            return this.processStandardMaterial(JSONMaterialObject, JSONMaterialObject.version);
        }
    };
    // #endregion Public Methods (1)
    // #region Private Methods (4)
    MaterialParser.prototype.loadCubeTextureFromJSON = function (jsonTexDef) {
        return __awaiter(this, void 0, void 0, function () {
            var url, envMapFilenames, name_orig, i;
            return __generator(this, function (_a) {
                if (jsonTexDef === undefined)
                    return [2 /*return*/, Promise.reject(new LoadCubeTextureFromJSONError())];
                if (typeof jsonTexDef === 'string' || Array.isArray(jsonTexDef)) {
                    jsonTexDef = { href: jsonTexDef };
                }
                envMapFilenames = ['px', 'nx', 'pz', 'nz', 'py', 'ny'];
                // check if name is a JSON.stringified version of an array of urls
                if (GlobalUtils_1.default.typeCheck(jsonTexDef.href, 'string') && jsonTexDef.href.startsWith('["https') && jsonTexDef.href.endsWith('"]')) {
                    name_orig = jsonTexDef.href;
                    try {
                        jsonTexDef.href = JSON.parse(name_orig);
                    }
                    catch (e) {
                        jsonTexDef.href = name_orig;
                    }
                }
                // deal with string or array, define names for loading and caching
                if (Array.isArray(jsonTexDef.href)) {
                    url = jsonTexDef.href;
                    if (url.length !== 6)
                        return [2 /*return*/, Promise.reject(new LoadCubeTextureFromJSONError())];
                }
                // define urls for 6 cube images ourselves
                if (url === undefined) {
                    url = [];
                    i = void 0;
                    if (jsonTexDef.href.startsWith('https://') || jsonTexDef.href.startsWith('http://')) {
                        if (!jsonTexDef.href.endsWith('/')) {
                            jsonTexDef.href += '/';
                        }
                        for (i = 0; i < envMapFilenames.length; i++)
                            url.push(jsonTexDef.href + envMapFilenames[i] + '.jpg');
                    }
                    else {
                        return [2 /*return*/, Promise.reject(new Error())];
                    }
                }
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        return MaterialParser.cubeTextureLoader.load(url, function (cubeTex) { return resolve(cubeTex); }, null, function () { return reject(new LoadCubeTextureFromJSONError()); });
                    })];
            });
        });
    };
    MaterialParser.prototype.loadTextureFromJSON = function (jsonTexDef) {
        if (typeof jsonTexDef === 'string') {
            jsonTexDef = { href: jsonTexDef };
        }
        if (!jsonTexDef.hasOwnProperty('href') && !jsonTexDef.hasOwnProperty('canvas')) {
            return Promise.reject(new Error('Input object is not a valid JSON texture definition.'));
        }
        var options = {
            wrapS: [0, 1, 2].includes(jsonTexDef.wrapS) ? jsonTexDef.wrapS : 0,
            wrapT: [0, 1, 2].includes(jsonTexDef.wrapT) ? jsonTexDef.wrapT : 0,
            offset: jsonTexDef.offset || [0, 0],
            repeat: jsonTexDef.repeat || [1, 1],
            rotation: jsonTexDef.rotation || 0,
            center: jsonTexDef.center || [0, 0],
            color: jsonTexDef.color || null
        };
        return loadTexture(jsonTexDef.href || jsonTexDef.canvas, options, this.requestHeaders)
            .then(function (texture) {
            if (options.color) {
                var t = toTinyColor_1.default(options.color);
                if (t && t.isValid()) {
                    texture.SDColor = t;
                }
                else {
                    // #SS-870 Warn about formatting error
                }
            }
            return (texture);
        }, function (err) {
            return Promise.reject(err);
        });
    };
    MaterialParser.prototype.processGemMaterial = function (materialDef) {
        var _this = this;
        var m = new MaterialPropertiesGem_1.default();
        // ints
        ['depth', 'resolution'].forEach(function (attr) {
            if (materialDef.hasOwnProperty(attr)) {
                var n = parseInt(materialDef[attr]);
                if (!isNaN(n) && isFinite(n)) {
                    if (attr === 'resolution') {
                        // power of 2
                        if (!(n & (n - 1)))
                            m[attr] = n;
                    }
                    else {
                        m[attr] = n;
                    }
                }
            }
        });
        // floats
        ['impurityScale', 'tracingTransparency', 'transparency', 'dispersion', 'refractionIndex', 'gamma', 'contrast', 'brightness'].forEach(function (attr) {
            if (materialDef.hasOwnProperty(attr)) {
                var n = parseFloat(materialDef[attr]);
                if (!isNaN(n) && isFinite(n)) {
                    switch (attr) {
                        case 'tracingTransparency':
                            m.tracingOpacity = 1 - n;
                            break;
                        case 'transparency':
                            m.opacity = 1 - n;
                            break;
                        default:
                            m[attr] = n;
                    }
                }
            }
        });
        // color
        ['colorTransferBegin', 'colorTransferEnd'].forEach(function (attr) {
            if (materialDef.hasOwnProperty(attr)) {
                var tc = toTinyColor_1.default(materialDef[attr]);
                if (tc && tc.isValid())
                    m[attr] = tc.toThreeColor();
            }
        });
        var promises = [];
        ['impurity', 'environment'].forEach(function (attr) {
            var prop = attr + 'texture';
            var propval = materialDef[prop];
            if (materialDef.hasOwnProperty(prop) && propval) {
                promises.push(_this.loadCubeTextureFromJSON(propval)
                    .then(function (texture) { return m[attr + 'Map'] = texture; }));
            }
        });
        return Promise.all(promises)
            .then(function () {
            m._json = materialDef;
            return m;
        });
    };
    /**
                 * Initialize this object from model view interface material defintion of version 2.0
                 * @private
                 * @param  {Object} materialDef Model view material definition, version 2.0
                 * @param {String} version Version string, currently one of '1.0', '2.0' or '3.0'
                 * @return {Promise<MaterialAttributes>}    Pointer to this object if successful.
                 */
    MaterialParser.prototype.processStandardMaterial = function (materialDef, version) {
        var e_1, _a;
        var _this = this;
        var supportedVersions = ['1.0', '2.0', '3.0'];
        if (supportedVersions.indexOf(version) == -1) {
            return Promise.reject(new Error('Material definition has unknown version.'));
        }
        var m = new MaterialPropertiesStandard_1.MaterialPropertiesStandard();
        if (version === '1.0') {
            if (materialDef.shine != null)
                materialDef.metalness = Math.min(1, materialDef.shine);
            if (materialDef.shine != null)
                materialDef.roughness = 1 - (Math.min(1, materialDef.shine));
            if (materialDef.hasOwnProperty('diffuse') && !materialDef.hasOwnProperty('color'))
                materialDef.color = materialDef.diffuse;
        }
        // floats
        ['metalness', 'roughness', 'alphaThreshold', 'shadowOpacity', 'lightReflectivity',
            'transparency', 'bumpAmplitude'
        ].forEach(function (attr) {
            if (materialDef.hasOwnProperty(attr)) {
                var n = parseFloat(materialDef[attr]);
                if (!isNaN(n) && isFinite(n)) {
                    switch (attr) {
                        case 'transparency':
                            m.opacity = 1 - n;
                            m.transparent = n > 0;
                            break;
                        case 'bumpAmplitude':
                            m.bumpScale = n;
                            break;
                        default:
                            m[attr] = n;
                    }
                }
            }
        });
        // color
        ['color',].forEach(function (attr) {
            if (materialDef.hasOwnProperty(attr)) {
                var tc = toTinyColor_1.default(materialDef[attr]);
                if (tc && tc.isValid())
                    m[attr] = tc.toThreeColor();
            }
        });
        // 3D noise properties (only from 3.0 onwards)
        if (materialDef.hasOwnProperty('threeDNoise')) {
            m.threeDNoiseOpacity = materialDef.threeDNoise.opacity || 0.0;
            m.threeDNoiseID = materialDef.threeDNoise.noiseID || 0;
            m.threeDNoiseScale = materialDef.threeDNoise.scale || 1.0;
            m.threeDNoiseDistanceFade = materialDef.threeDNoise.distance || 0.0;
        }
        // Line Material
        if (materialDef.hasOwnProperty('line')) {
            m.line.type = GlobalUtils_1.default.typeCheck(materialDef.line.type, 'string') ? materialDef.line.type : 'basic';
            m.line.lineWidth = GlobalUtils_1.default.typeCheck(materialDef.line.lineWidth, 'notnegative') ? materialDef.line.lineWidth : 1;
            m.line.dashSize = GlobalUtils_1.default.typeCheck(materialDef.line.dashSize, 'notnegative') ? materialDef.line.dashSize : 3;
            m.line.gapSize = GlobalUtils_1.default.typeCheck(materialDef.line.gapSize, 'notnegative') ? materialDef.line.gapSize : 1;
            m.line.scale = GlobalUtils_1.default.typeCheck(materialDef.line.scale, 'notnegative') ? materialDef.line.scale : 1;
        }
        if (materialDef.hasOwnProperty('side')) {
            m.side = THREE.DoubleSide;
            if (materialDef.side === 'front')
                m.side = THREE.FrontSide;
            else if (materialDef.side === 'back')
                m.side = THREE.BackSide;
        }
        // textures
        var promises = [];
        if (materialDef.hasOwnProperty('bitmaptexture')) {
            // in version 3.0, we might get an array of color textures
            // #SS-870 document this
            if (Array.isArray(materialDef.bitmaptexture)) {
                if (materialDef.bitmaptexture.length === 0) {
                    return Promise.resolve(null);
                }
                var colorTexPromiseArray = [];
                try {
                    for (var _b = __values(materialDef.bitmaptexture), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var tex = _c.value;
                        colorTexPromiseArray.push(this.loadTextureFromJSON(tex));
                    }
                }
                catch (e_1_1) { e_1 = { error: e_1_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_1) throw e_1.error; }
                }
                promises.push(Promise.all(colorTexPromiseArray)
                    .then(function (textures) {
                    if (textures.length > 1) {
                        m.additionalMaps = [];
                        m.mapPropertyType = [];
                        m.mapPropertyColor = [];
                        m.uvTransformAddMap = [];
                        for (var i = 1, iBound = textures.length; i < iBound; ++i) {
                            var tex = textures[i];
                            m.additionalMaps.push(tex);
                            m.mapPropertyType.push(tex.hasOwnProperty('SDColor') ? 1 : 0);
                            var c = tex.hasOwnProperty('SDColor') && tex.SDColor ? tex.SDColor.toThreeColor() : new THREE.Color();
                            m.mapPropertyColor.push(c);
                            m.uvTransformAddMap.push(tex.uvTransform);
                        }
                    }
                    return m.map = textures[0];
                }));
            }
            else {
                promises.push(this.loadTextureFromJSON(materialDef.bitmaptexture)
                    .then(function (texture) { return m.map = texture; }));
            }
        }
        ['metalness', 'roughness', 'bump', 'normal', 'transparency'].forEach(function (attr) {
            if (materialDef.hasOwnProperty(attr + 'texture')) {
                promises.push(_this.loadTextureFromJSON(materialDef[attr + 'texture'])
                    .then(function (texture) {
                    if (attr === 'transparency') {
                        m.alphaMap = texture;
                        m.transparent = true;
                    }
                    else {
                        m[attr + 'Map'] = texture;
                    }
                }));
            }
        });
        return Promise.all(promises)
            .then(function () {
            m._json = materialDef;
            return m;
        });
    };
    // #region Properties (4)
    // TODO: it is static because instance of material parser is created multiple times, ideally, parser should be resolved in root and never instanced again
    MaterialParser.cubeTextureLoader = new THREE.CubeTextureLoader();
    return MaterialParser;
}());
exports.MaterialParser = MaterialParser;
